import React, { useEffect, useRef } from 'react';
import { useLocation } from '@reach/router';

const HubSpotForm = ({ region = "na1", portalId, formId, ...props }) => {
    const formRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        const scriptSrc = 'https://js.hsforms.net/forms/embed/developer/23159754.js';
        if (formRef.current) {
            formRef.current.innerHTML = '';
        }

        const script = document.createElement('script');
        script.src = scriptSrc;
        script.defer = true;
        script.onload = () => {
            console.log('HubSpot developer script reloaded.');
        };
        document.body.appendChild(script);

        setTimeout(() => {
            const errorAlert = document.querySelector('.footer-subscribe-form .hsfc-ErrorAlert');
            if (errorAlert && errorAlert.innerText.includes('Please complete this required field.')) {
                errorAlert.style.display = 'none';
            }
        }, 1000);

        return () => {
            document.body.removeChild(script);
        };
    }, [location.pathname]);

    return (
        <>
            <style>{`
                 .footer-subscribe-form {
                    max-width:480px;
                 }
                .footer-subscribe-form .hs-error-msgs,
                .footer-subscribe-form label,
                .footer-subscribe-form .hs_description {
                  display: none;
                }
                .footer-subscribe-form .hsfc-Step__Content {
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: flex-start;
                    gap: 8px;
                    max-width: 100%;
                    flex: auto 1;
                    color:#fafafa;
                }
                .hsfc-RichText {
                    color:#fafafa;    
                }
                .footer-subscribe-form .hsfc-Step__Content .hsfc-Row {
                    display:none;
                }
                .footer-subscribe-form .hsfc-Step__Content .hsfc-Row:first-child {
                    display:flex;
                    flex: auto;
                   
                }
                .footer-subscribe-form .hsfc-Step__Content .hsfc-NavigationRow {
                    margin: 0;
                    padding: 0;
                    flex: auto;
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;
                }
                
                .footer-subscribe-form .hsfc-EmailField {
                    width:100%;
                }
                .footer-subscribe-form .hsfc-Step__Content .hsfc-EmailField input {
                    width:100%;
                    border:1px solid #f5f8fa;
                }
                .subscribe-header {
                    color:#fafafa;
                    font-size:1rem;
                    margin:0;
                    padding:0 0 6px 0;
                }
            `}</style>
            <div>
                <h6 className="subscribe-header" style={{ marginBottom: '8px' }}>Stay Connected.</h6>
                <div
                    ref={formRef}
                    className="hs-form-html footer-subscribe-form"
                    data-region={region}
                    data-portal-id={portalId}
                    data-form-id={formId}
                    {...props}
                />
            </div>
        </>
    );
};

export default HubSpotForm;